export const mandatoryFaq = [
  {
    question: "動かない車やタイヤがない車も対象ですか？",
    answer:
      "はい。走らない車やタイヤがない車も相談・査定対象です。車両・書類の状況を確認して査定します。",
  },
  {
    question: "レッカー代はかかりますか？",
    answer: "かかりません。レッカー代は無料です。",
  },
  {
    question: "抹消手続きに費用はかかりますか？",
    answer: "かかりません。抹消手続きは無料で対応します。",
  },
  {
    question: "問い合わせから引き取りまで、どのくらいかかりますか？",
    answer:
      "電話査定は3分です。現地での引き取り作業は約5分です。引き取りは最短当日に対応します。引き取り日時は地域・受付状況、現地作業時間は車両状態・積載状況により前後する場合があります。",
  },
] as const;

export const additionalFaq = [
  {
    question: "車検証が手元にない場合も相談できますか？",
    answer:
      "はい。車検証が手元にない場合も、まずは分かる範囲で車両や書類の状況をお知らせください。",
  },
  {
    question: "買取代金はいつ受け取れますか？",
    answer: "査定・契約内容をご確認いただいたうえで、引き取り時に現金でお支払いします。",
  },
] as const;

export const faqItems = [...mandatoryFaq, ...additionalFaq] as const;
